import * as React from 'react';
import ApplicationInvitations from './ApplicationInvitations';
import type { Invite } from './ApplicationInvitations';
import ApplicationsList from './ApplicationsList';
import type { Application } from './ApplicationsList';

interface ManageInvitationsProps {
  invitations: Invite[];
  applications: Application[];
  authenticity_token: string;
  edit_profile_path?: string;
}

const ManageInvitations: React.FC<ManageInvitationsProps> = ({ invitations, applications, authenticity_token, edit_profile_path }) => {
    const [state, setState] = React.useState<{
        invitations: Invite[];
        applications: Application[];
        loaded: boolean;
    }>({
        invitations, applications: applications || [], loaded: false
    });
    const [activeTab, setActiveTab] = React.useState('invitations');

    console.log(state);

    const getNotes = () => {
        // get_notes({ callback: notes => setState({ ...state, notes, loaded: true }) });
    }

    React.useEffect(() => getNotes(), []);

    const getTotalCount = () => state.invitations.length + state.applications.length;

    return (
        <div className="container">
            <div className="row browsing-font mt-5 px-2">
                <div className="col-12 card shadow mb-4 px-0 browsing-card-design" id="application-invites-list">
                    <div className="card-header browsing-cards-head">
                        <i className="fas fa-briefcase"></i> My Applications & Invitations
                    </div>

                    {getTotalCount() === 0 ? (
                        <div className="padding-right p-2">
                            <div className="text-center py-5">
                                <img
                                    src="/images/missing.svg"
                                    alt=""
                                    height={100}
                                />
                                <div className="text-center">
                                    <h4 className="fullname">No Applications or Invitations Yet</h4>
                                    <p>Once you apply for jobs or employers invite you, they will appear here.</p>
                                    <a className="btn btn-primary btn-lg" href={edit_profile_path}>
                                        <i className="fas fa-user-edit me-2"></i>
                                        Edit Profile
                                    </a>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* Tab Navigation */}
                            <ul className="nav nav-tabs temp-requests-tabs mb-0" id="applicationsInvitesTabs" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === 'invitations' ? 'active' : ''}`}
                                        id="invitations-tab"
                                        onClick={() => setActiveTab('invitations')}
                                        type="button"
                                        role="tab"
                                        aria-controls="invitations"
                                        aria-selected={activeTab === 'invitations'}
                                    >
                                        <i className="fa fa-envelope me-2"></i>
                                        Invitations
                                        {state.invitations.length > 0 && (
                                            <span className="badge bg-primary ms-2">{state.invitations.length}</span>
                                        )}
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === 'applications' ? 'active' : ''}`}
                                        id="applications-tab"
                                        onClick={() => setActiveTab('applications')}
                                        type="button"
                                        role="tab"
                                        aria-controls="applications"
                                        aria-selected={activeTab === 'applications'}
                                    >
                                        <i className="fa fa-file-text me-2"></i>
                                        Applications
                                        {state.applications.length > 0 && (
                                            <span className="badge bg-success ms-2">{state.applications.length}</span>
                                        )}
                                    </button>
                                </li>
                            </ul>

                            {/* Tab Content */}
                            <div className="tab-content" id="applicationsInvitesTabContent">
                                {activeTab === 'invitations' && (
                                    <ApplicationInvitations
                                        invites={state.invitations}
                                        authenticity_token={authenticity_token}
                                    />
                                )}

                                {activeTab === 'applications' && (
                                    <ApplicationsList
                                        applications={state.applications}
                                        authenticity_token={authenticity_token}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ManageInvitations;
